/**
 * API interceptor for 'Notify' 
 * from NotificationsModule in @buildiumprivate/angularjs-core/dist/notifications
*/

export function NotifyShimService(
    ToastMessageStateService,
) {
    const service = {};

    service.success = function success(message) {
        return ToastMessageStateService.success(message);
    };

    service.error = function error(message) {
        return ToastMessageStateService.error(message);
    };

    service.confirmation = function confirmation(message, messageType) {
        if (messageType && messageType === 'Error') {
            return ToastMessageStateService.error(message);
        } else {
            return ToastMessageStateService.success(message);
        }
    };

    service.notifyOnNavigation = function notifyOnNavigation(message, messageType) {
        if (messageType && messageType === 'Error') {
            return ToastMessageStateService.errorAfterNavigate(message);
        } else {
            return ToastMessageStateService.successAfterNavigate(message);
        }
    };

    service.displayConfirmationMessage = function displayConfirmationMessage(message) {
        return ToastMessageStateService.displayMessageOnNavigate(message);
    };

    return service;
}
NotifyShimService.$inject = [
    'ToastMessageStateService',
];
